import { InsightsMetricActionsType } from './ContactsSummary';

export enum ShippingRange {
  WEEKLY = 'weekly',
  BIWEEKLY = 'bi-weekly',
  MONTHLY = 'monthly',
  QUARTERLY = 'quarterly',
}

export enum ChannelTotalType {
  ALL = 'all',
  EMAIL = 'email',
  INBOX = 'inbox',
  ONSITE = 'onsite',
  SMS = 'sms',
}

// cspell:disable
export enum ChannelTrackingType {
  DELIVERED = 'delivered',
  OPENS = 'opens',
  CLICKS = 'clicks',
  BOUNCES = 'bounces',
  UNSUBSCRIBES = 'unsubscribes',
  FAILED = 'failed',
  CLEANED = 'cleaned',
  IMPRESSIONS = 'impressions',
  HITS = 'hits',
  PAGES = 'pages',
  CONVERSION_RATE = 'conversionRate',
}
// cspell:enable

export interface ISectionMetrics {
  [key: string]: {
    title: string;
    metrics: ChannelTrackingType[];
    colors: string[];
    tooltip?: string;
  };
}

export interface ShippingGraphMetric {
  date: string;
  delivered: number;
  opens: number;
  bounces: number;
  clicks: number;
  unsubscribes: number;
  cleaned: number;
  impressions: number;
  hits: number;
  pages: number;
  conversionRate: number;
}

export interface ShippingMetadataMetric {
  totalAll: number;
  totalEmail: number;
  totalSms: number;
  totalInbox: number;
  totalOnsite: number;
}

export interface ShippingFilters {
  startDate: string;
  endDate: string;
  filterType: InsightsMetricActionsType;
}
